'use client'

import { SentenceMakingQuestion } from '@entities/lesson'
import { LessonReviewAnswerStatus, lessonReviewAnswerStatusSchema } from '@features/lesson-review'
import { useTranslation } from '@shared/config/i18n'
import React from 'react'
import { match } from 'ts-pattern'

import { HStack, Input, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: SentenceMakingQuestion
  value: Undefinable<string>
  handleChangeCurrentFunnelValue: (value: string) => void
  canNavigateNextFunnel: boolean
  status: LessonReviewAnswerStatus
  handleChangeCurrentStatus: (status: LessonReviewAnswerStatus) => void
}

export const SentenceMakingQuizFunnel = ({
  question,
  value,
  handleChangeCurrentFunnelValue,
  canNavigateNextFunnel,
  status,
  handleChangeCurrentStatus,
}: Props) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <VStack className="py-5 gap-5">
        <Typography className="text-[22px] font-normal">{question.source.body.original_sentence}</Typography>

        <VStack className="gap-2">
          <HStack className="gap-1">
            <Typography size="h1">{question.source.body.vocab}</Typography>
          </HStack>
          <Typography size="h6" className="font-normal text-gray-500">
            {question.source.body.vocab_translation}
          </Typography>
        </VStack>
      </VStack>

      <VStack className="gap-2">
        <Typography className="text-gray-400" size="h6">
          {t('lesson.quiz.answerInput')}
        </Typography>
        <Input
          className="w-full"
          onChange={(event) => handleChangeCurrentFunnelValue(event.target.value)}
          value={value ?? ''}
          disabled={canNavigateNextFunnel}
          name="answer"
          variant={match(status)
            .with(lessonReviewAnswerStatusSchema.Enum.INCORRECT, () => 'error' as const)
            .otherwise(() => 'default' as const)}
          onFocus={() => {
            handleChangeCurrentStatus(lessonReviewAnswerStatusSchema.Enum.NOT_ANSWERED)
          }}
        />
      </VStack>
    </React.Fragment>
  )
}
